import React from 'react'
import SliderTestimonial from '../../component/slidercomponent/SliderTestimonial'
import SliderHomeTestimonials from '../../component/SliderHomeTestimonials'

const HomeTestimonials = () => {
    return (
        <>
            <div className="our-testimonials" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="row section-row">
                        <div className="col-lg-12">
                            {/* Section Title Start */}
                            <div className="section-title section-title-center">
                                <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our Testimonials</h3>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: 'center', position: 'relative' }}>
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            Trusted By Families, Loved For Flavor, Remembered For Quality
                                        </div>
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* Testimonial Slider Start */}
                            <div className="testimonial-slider">
                                <div className="swiper swiper-initialized swiper-horizontal swiper-backface-hidden">
                                    <div >
                                        <SliderHomeTestimonials />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default HomeTestimonials